import actions from './actions';
import mutations from './mutations';
import state from './initialState';

const campaigns = {
  namespaced: true,

  state,

  mutations,

  actions,
};

export default campaigns;
